// E-learning routes (25-9-2026), shared by the beheerder and superbeheerder
// routers; the behandelaar router gets the read-only results. Plain .ts with
// createElement so the file exports no components (react-refresh lint).

import { createElement } from 'react'
import { RouteObject } from 'react-router'
import {
  Chapters,
  ElearningForm,
  Layout,
  Library,
  List,
  ModuleForm,
  Modules,
  PageEditor,
  Pages,
  Participant,
  Results,
} from './elearningPages'

/** The module workspace, under an e-learning or under the library. */
const workspace: RouteObject[] = [
  { path: 'modules/nieuw', element: createElement(ModuleForm) },
  { path: 'modules/:moduleId', element: createElement(Chapters) },
  { path: 'modules/:moduleId/bewerken', element: createElement(ModuleForm) },
  { path: 'hoofdstukken/:chapterId', element: createElement(Pages) },
  { path: 'hoofdstukken/:chapterId/nieuw', element: createElement(PageEditor, { mode: 'slot' }) },
  { path: 'samenvattingen/:summaryId', element: createElement(Pages) },
  { path: 'samenvattingen/:summaryId/nieuw', element: createElement(PageEditor, { mode: 'slot' }) },
  { path: 'paginas/:pageId', element: createElement(PageEditor, { mode: 'slot' }) },
]

/** Children of `management` for beheerder / superbeheerder. */
export const elearningRoutes: RouteObject[] = [
  {
    path: 'elearning',
    element: createElement(Layout),
    children: [
      { path: '', element: createElement(List) },
      { path: 'nieuw', element: createElement(ElearningForm) },
      { path: ':elearningId', element: createElement(Modules) },
      { path: ':elearningId/bewerken', element: createElement(ElearningForm) },
      { path: ':elearningId/resultaten', element: createElement(Results) },
      { path: ':elearningId/resultaten/:userId', element: createElement(Participant) },
      ...workspace.map((r) => ({ ...r, path: `:elearningId/${r.path}` })),
    ],
  },
  {
    path: 'elearning-bibliotheek',
    element: createElement(Layout),
    children: [
      { path: '', element: createElement(Library) },
      { path: 'bibliotheek-paginas/nieuw', element: createElement(PageEditor, { mode: 'library' }) },
      { path: 'bibliotheek-paginas/:libraryPageId', element: createElement(PageEditor, { mode: 'library' }) },
      ...workspace,
    ],
  },
]

/** Children of `management` for behandelaar: results of their clients. */
export const elearningResultsRoutes: RouteObject[] = [
  {
    path: 'elearning',
    element: createElement(Layout),
    children: [
      { path: '', element: createElement(List) },
      { path: ':elearningId/resultaten', element: createElement(Results) },
      { path: ':elearningId/resultaten/:userId', element: createElement(Participant) },
    ],
  },
]
